// Standalone entry so server/worker bundles (e.g. `actor-database.server.ts` via
// `wrap-actor-database.ts`) can import the transaction buffer without dragging
// in the platform sqlite machinery behind the main entry points.
export { runWithBufferedDatabaseChanges } from "#database-change-transaction-buffer";
